import { compose } from 'recompose'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import withSpinning from '../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../elements/HOC/withSubDropdown'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'

const RatesTypeSelect = compose(
  withSelectFetch({
    dropdown: 'employee',
    name: 'contract',
    cache: true,
  }),
  withSpinning,
  withSubDropdown({ name: 'rates' }),
  withSort
)(CustomSelect)
export default RatesTypeSelect
